import { useCallback, useEffect, useRef } from 'react';

export const hashRoutes = {
  Wallet: '/profile/withdrawal',
  Profile: '/profile/account',
  Trade: '/trade',
  MyTools: '/profile/my-assets',
};

export const useCrossAppNavigation = () => {
  const navigateRef = useRef('');
  const metaDataRef = useRef(null);

  const handleOnClick = useCallback((page, additionalInfo) => {
    if (!page) return;

    navigateRef.current = hashRoutes[page];
    metaDataRef.current = additionalInfo || null;

    window.open(`${process.env.REACT_APP_ZOGOEX_URL}/app`, '_blank');
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_ZOGOEX_URL) return;

      if (event.data?.type === 'REQUEST_TOKEN' && navigateRef.current) {
        const token = localStorage.getItem('userData');

        event.source?.postMessage(
          {
            type: 'SEND_TOKEN',
            token,
            location: navigateRef.current,
            ...(metaDataRef.current && {
              metaData: metaDataRef.current,
            }),
          },
          event.origin,
        );

        navigateRef.current = '';
        metaDataRef.current = null;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return {
    handleOnClick,
  };
};
